import React, { Component } from 'react';
import { Provider } from 'react-redux';
import Form from './form';
import {setForm} from '../actions/flexibleFormActions';
import store from '../store/store';
import {actions} from "react-fields";
import formApi from '../api/flexibleFormApi';

export default class Root extends Component {

    componentDidMount() {
        if (this.props.form_id) {
            formApi.getForm(this.props.form_id).then( async (response) => {
                store.dispatch(setForm(response));
            }).catch(error => {
                console.log(error);
            })
        } else {
            store.dispatch(setForm(this.props.form));
        }
    }

    render() {
        return (
            <Provider store={store}>
                <Form subheader={this.props.subheader} />
            </Provider>
        );
    }
}